<template>
  <button
    type="button"
    :disabled="disabled"
    @click="clickTrigger"
    :class="[
      'v-btn v-btn--block v-btn--contained v-btn--rounded theme--light v-size--large mt-10', (user && user.loading) || disabled ? 'disabled' : 'primary'
    ]"
    :style="['color: #ffffff', (user && user.loading) || disabled ? {'cursor': 'not-allowed'} : {}]"
  >
    {{ label }}
  </button>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'StateButton',
  props: {
    disabled: Boolean,
    label: String
  },
  methods: {
    clickTrigger() {
      this.$emit('btn-click');
    }
  },
  computed: {
    ...mapGetters(['user'])
  }
});
</script>

<style scoped lang="scss">
.v-btn {
  width: 135px;
}
@media (min-width: 600px) {
  .v-btn {
    width: 220px;
  }
}
</style>

<i18n src="../localization/texts.json"></i18n>
